import { render } from "./Empty.vue?vue&type=template&id=4c5b9636&scoped=true"
const script = {}

import "./Empty.vue?vue&type=style&index=0&id=4c5b9636&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5b9636"]])

export default __exports__